// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"8f5c603b","473":"10cf3de0","737":"e6ef2db6","787":"c58be9c0"}[chunkId] + ".chunk.js";
};